import i18n from "../i18n";
import { FilterType } from "./enums";

export const orgId = "Rombo Logística";

export const parseErrorBody = (textBody) => {
    let parsedBody;
    try {
        const cleanedBody = textBody.replace(/\\\"/g, '"').replace(/(^"|"$)/g, '');
        const errorData = JSON.parse(cleanedBody);
        const firstError = errorData[0];
        parsedBody = firstError.msg;
    } catch (e) {
        parsedBody = textBody;
    }
    return parsedBody;
};

export const getAddressInfo = ({ origin, destination, scales, info }) => ({
    origin: origin || info?.origin,
    destination: destination || info?.destination,
    scales: scales || info?.scales,
});

export const minimumLoadingTime = 2000;

export const cancellationReasons = [
    { value: "CANCELLED_BY_CLIENT", label: i18n.t("CancellationImputableToClient") },
    { value: "CANCELLED_BY_ROMBO", label: i18n.t("CancellationImputableToRombo") },
    { value: "CANCELLED_BY_CAPTURE_ERROR", label: i18n.t("CancellationCaptureError") }
];

export const statusMap = {
    DELETED: "Cancelled",
    FINISHED: "Completed",
    ASSIGNED: "Assigned",
    UNASSIGNED: "Unassigned",
    STARTED: "Started",
};

export const isPartnerAllowed = (partnerId) => {
    const allowedPartners = [3764, 4356, 5300, 4661, 3891, 3896]; 
    return allowedPartners.includes(Number(partnerId));
};

export const getFrequentAddresses = (companyId, employeeAddresses = []) => {
    const companyAddresses = [];
    
    if ([1, 6823].includes(companyId)) {
        companyAddresses.push(
            "Norte 45 847 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
            "Calle Pte. 128 550 Industrial Vallejo, Azcapotzalco, 02300 Ciudad de México, CDMX",
            "Calz. Vallejo 1849 San José de la Escalera, Gustavo A. Madero, 07630 Ciudad de México, CDMX"
        );
    } else if ([3867, 4355].includes(companyId)) {
        companyAddresses.push(
            "Av. de los Insurgentes Sur 3500, Manantial Peña Pobre, Tlalpan, 14060 Ciudad de México, CDMX"
        );
    } else if ([3996, 4362].includes(companyId)) {
        companyAddresses.push(
            "Rosa Blanca 63, Molino de Rosas, Álvaro Obregón, 01470 Ciudad de México, CDMX"
        );
    } else if ([7784].includes(companyId)) {
        companyAddresses.push(
            "Periódico Reforma, Avenida México Coyoacán, Santa Cruz Atoyac, Ciudad de México, CDMX"
        );
    }
    
    const employeeAddressList = employeeAddresses.map(addr => addr.address.description);
    
    return [...new Set([...companyAddresses, ...employeeAddressList])];
};

export const handleSearchFilters = (
    val,
    typeSearch,
    filtersOpts,
    setFiltersOpts,
    setReloadList,
    setCurrentPage,
    localStorageKey,
    setStateFunctions = {}
  ) => {
    let opts = { ...filtersOpts };
  
    switch (typeSearch) {
      case FilterType.COMPANY:
        if (val) opts.data.filters.partner_id = val;
        else delete opts.data.filters.partner_id;
        if (setStateFunctions.setFCompany) setStateFunctions.setFCompany(val);
        break;
      case FilterType.STATUS:
        if (val) opts.data.filters.status = val;
        else delete opts.data.filters.status;
        if (setStateFunctions.setStatusService) setStateFunctions.setStatusService(val);
        break;
      case FilterType.TYPE:
        if (val) opts.data.filters.type = val;
        else delete opts.data.filters.type;
        if (setStateFunctions.setTypeService) setStateFunctions.setTypeService(val);
        break;
      case FilterType.CODE:
        if (val) opts.data.filters.code = val;
        else delete opts.data.filters.code;
        if (setStateFunctions.setServiceNumber) setStateFunctions.setServiceNumber(val || '');
        break;
      case FilterType.PLACE:
        if (val) opts.data.filters.place_id = val;
        else delete opts.data.filters.place_id;
        if (setStateFunctions.setPlaceService) setStateFunctions.setPlaceService(val);
        break;
      case FilterType.SCHEDULED:
        if (val) opts.data.filters.scheduled_type = val;
        else delete opts.data.filters.scheduled_type;
        if (setStateFunctions.setScheduledType) setStateFunctions.setScheduledType(val);
        break;
      case FilterType.PLATE:
        if (val) opts.data.filters.plate = val;
        else delete opts.data.filters.plate;
        if (setStateFunctions.setPlateService) setStateFunctions.setPlateService(val);
        break;
      case FilterType.START_DATETIME:
        if (val) opts.data.filters.start_datetime = val;
        else delete opts.data.filters.start_datetime;
        if (setStateFunctions.setStartDateTime) setStateFunctions.setStartDateTime(val);
        break;
      case FilterType.END_DATETIME:
        if (val) opts.data.filters.end_datetime = val;
        else delete opts.data.filters.end_datetime;
        if (setStateFunctions.setEndDateTime) setStateFunctions.setEndDateTime(val);
        break;
      case FilterType.START_DATE:
        if (val) opts.data.filters.start_date = val;
        else delete opts.data.filters.start_date;
        if (setStateFunctions.setStartDate) setStateFunctions.setStartDate(val);
        break;
      case FilterType.START_TIME:
        if (val) opts.data.filters.start_time = val;
        else delete opts.data.filters.start_time;
        if (setStateFunctions.setStartTime) setStateFunctions.setStartTime(val);
        break;
      case FilterType.END_DATE:
        if (val) opts.data.filters.end_date = val;
        else delete opts.data.filters.end_date;
        if (setStateFunctions.setEndDate) setStateFunctions.setEndDate(val);
        break;
      case FilterType.END_TIME:
        if (val) opts.data.filters.end_time = val;
        else delete opts.data.filters.end_time;
        if (setStateFunctions.setEndTime) setStateFunctions.setEndTime(val);
        break;
      case FilterType.PAGE:
        opts.data.filters.page = val;
        setCurrentPage(val);
        break;
      default:
        break;
    }
  
    if (typeSearch !== FilterType.PAGE) {
      opts.data.filters.page = 1;
      setCurrentPage(1);
    }
  
    if (Object.keys(opts.data.filters).length > 0) {
      localStorage.setItem(localStorageKey, JSON.stringify(opts));
    } else {
      localStorage.removeItem(localStorageKey);
    }
  
    setFiltersOpts(opts);
    setReloadList(true);
};

export const allowedHoursOptions = [
  { value: "22:10", label: "22:10" },
  { value: "22:30", label: "22:30" },
  { value: "23:10", label: "23:10" },
  { value: "23:30", label: "23:30" },
  { value: "00:10", label: "00:10" },
  { value: "00:30", label: "00:30" },
  { value: "01:10", label: "01:10" },
  { value: "01:30", label: "01:30" },
  { value: "02:10", label: "02:10" },
  { value: "02:30", label: "02:30" },
];

export const CAROUSEL_TEXTS = {
  es: [
    "Rombo: Acelerando la eficiencia de tu flotilla",
    "Optimizando rutas y reduciendo costos operativos",
    "Tecnología mexicana para el transporte del futuro",
    "¿Sabías que Rombo reduce hasta un 30% los tiempos de espera?",
    "Conectamos conductores y pasajeros de manera inteligente",
    "Innovación que mueve a México",
    "Datos en tiempo real para decisiones más acertadas",
    "Seguridad y transparencia en cada viaje",
    "La revolución del transporte comienza aquí"
  ],
  en: [
    "Rombo: Accelerating your fleet's efficiency",
    "Optimizing routes and reducing operational costs",
    "Mexican technology for the future of transportation",
    "Did you know Rombo reduces waiting times by up to 30%?",
    "Connecting drivers and passengers intelligently",
    "Innovation that moves Mexico forward",
    "Real-time data for better decisions",
    "Security and transparency in every ride",
    "The transportation revolution starts here"
  ]
};